// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  numero_WhatsApp: "",
  numero_telefono: "tel:+390815511353",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: false,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  */

  urlWeb: 'https://discentya.ilas-formazione.it/',
  urlMaterialeDidattico: 'https://discentya.ilas-formazione.it/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.ilas-formazione.it/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.ilas-formazione.it/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.ilas-formazione.it/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.ilas-formazione.it/api/',

  urlStampa: 'https://discentya.ilas-formazione.it/stampe/',

  urlAttestati: 'https://discentya.ilas-formazione.it/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.ilas-formazione.it/pages/certificate/',
  urlImagePartners: 'https://discentya.ilas-formazione.it/assets/media/partners/',

};

